export const DAO_CODE = 'DASHBOARD_CONSULTANT_SALES' + '_DAO';